import { motion } from 'framer-motion';

export default function Resources() {
  const sections = [
    {
      label: "Blog Posts – AI trends, ethical data, case studies",
      icon: "📝"
    },
    {
      label: "Whitepapers & Reports – Research-backed insights",
      icon: "📄"
    },
    {
      label: "Webinars – Live & recorded sessions",
      icon: "🎥"
    },
    {
      label: "Guides – Best practices in data services",
      icon: "📘"
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-slate-100 to-slate-200">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight font-orbitron">
          Resources / Blog
        </h2>
        <p className="text-lg text-gray-600 mt-4">
          Explore insights, research, and best practices powering the future of ethical AI.
        </p>
      </div>

      <ul className="space-y-6 max-w-2xl mx-auto">
        {sections.map(({ label, icon }, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.03 }}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition cursor-pointer flex items-start gap-4"
          >
            <div className="text-3xl">{icon}</div>
            <p className="text-gray-800 text-base font-medium">{label}</p>
          </motion.li>
        ))}
      </ul>
    </section>
  );
}
